import type { CaseItem, ClientItem, Product, Service } from '../types';

/** 产品数据（图标 key 对应 lucide-react 图标） */
export const products: Product[] = [
  {
    id: 1,
    icon: 'shield-cog-corner',
    name: '社区安全基层治理平台',
    description:
      '以网格化管理为核心，构建"发现-处置-反馈"治理闭环，全面提升基层治理数字化水平。',
    tags: ['网格管理', '事件处置', '居民服务', '数据分析'],
  },
  {
    id: 2,
    icon: 'siren',
    name: '应急指挥平台',
    description:
      '面向突发事件的统一指挥调度平台，实现多部门协同作战、资源快速调配与指挥决策可视化。',
    tags: ['应急调度', '快速响应', '协同处置', '指挥决策'],
  },
  {
    id: 3,
    icon: 'video',
    name: 'AI视频分析系统',
    description:
      '基于深度学习的视频智能分析系统，实时识别异常行为并自动预警，全天候守护安全。',
    tags: ['人脸识别', '行为分析', '异常检测', '实时预警'],
  },
  {
    id: 4,
    icon: 'cart',
    name: '社区电商平台',
    description:
      '面向社区的电商服务平台，支持商品在线交易与社区团购，让便民服务触手可及。',
    tags: ['商品管理', '在线交易', '社区团购', '便民服务'],
  },
  {
    id: 5,
    icon: 'clipboard',
    name: '调查问卷系统',
    description:
      '一站式在线问卷调研平台，从问卷设计、数据采集到统计分析全程数字化，洞察更高效。',
    tags: ['问卷设计', '在线调查', '数据采集', '统计分析'],
  },
  {
    id: 6,
    icon: 'folder',
    name: 'OA办公系统',
    description:
      '企业级协同办公平台，打通流程审批、信息管理与工作督办全链路，让组织运转更高效。',
    tags: ['流程审批', '协同办公', '信息管理', '工作督办'],
  },
];

/** 服务数据 */
export const services: Service[] = [
  {
    id: 1,
    icon: 'cctv',
    title: '智能安防监控',
    description: 'AI驱动的实时监控系统，覆盖园区、楼宇与重点区域，实现智能化安全防范。',
  },
  {
    id: 2,
    icon: 'scan-eye',
    title: '视频分析服务',
    description: '基于深度学习的视频内容分析，提供人脸识别、行为分析与异常事件检测。',
  },
  {
    id: 3,
    icon: 'brain-circuit',
    title: 'AI安全大脑',
    description: '智能安全决策引擎，融合多源数据与算法模型，辅助管理者快速科学决策。',
  },
  {
    id: 4,
    icon: 'database',
    title: '数据处理服务',
    description: 'AI驱动的数据治理与分析服务，让数据资产转化为业务洞察与安全价值。',
  },
  {
    id: 5,
    icon: 'messages-square',
    title: '技术咨询服务',
    description: '专业化的信息技术解决方案咨询服务，助力企业数字化规划与落地。',
  },

  {
    id: 6,
    icon: 'wrench',
    title: '安全运维服务',
    description: '7x24小时专业运维保障，快速响应、持续护航系统稳定运行。',
  },
];

/** 本地默认案例数据（未配置 Supabase 时使用） */
export const mockCases: CaseItem[] = [
  {
    id: 1,
    tags: ['智慧安防', 'AI视频分析', '园区安防'],
    title: '北京市气象局某园区智慧安防系统',
    description:
      '为气象局园区部署 AI 视频分析与智慧安防系统，实现全天候智能监测、人脸识别与异常预警。',
    image: '/images/cases/case-1.jpg',
  },
  {
    id: 2,
    tags: ['基层治理', '网格管理', '事件处置'],
    title: '平谷区某街道基层治理平台',
    description:
      '建设网格化基层治理平台，打通事件处置、居民服务与数据分析全流程，提升治理效能。',
    image: '/images/cases/case-4.jpg',
  },
  {
    id: 3,
    tags: ['社区治理', '居民服务', '数字化'],
    title: '平谷区某街道社区基层治理平台',
    description:
      '面向社区场景的基层治理数字化平台，实现网格管理精细化与居民服务便捷化。',
    image: '/images/cases/case-3.jpg',
  },
  {
    id: 4,
    tags: ['应急管理', '应急预案', '文物安全'],
    title: '文物安全事件应急预案知识库',
    description:
      '构建文物安全应急预案知识库，覆盖事件分级、处置流程与协同调度，守护文化遗产安全。',
    image: '/images/cases/case-2.jpg',
  },
];

/** 本地默认客户数据（未配置 Supabase 时使用） */
export const mockClients: ClientItem[] = [
  { id: 1, name: '清华大学', logo: '/images/clients/tsinghua.png' },
  { id: 2, name: '中国人民公安大学', logo: '/images/clients/ppsuc.png' },
  { id: 3, name: '北方工业大学', logo: '/images/clients/ncut.png' },
  { id: 4, name: '北京市气象局', logo: '/images/clients/tsinghua.png' },
  { id: 5, name: '平谷区某街道办事处', logo: '/images/clients/tsinghua.png' },
  { id: 6, name: '平谷区某街道社区', logo: '/images/clients/tsinghua.png' },
  { id: 7, name: '某街道办事处', logo: '/images/clients/tsinghua.png' },
  { id: 8, name: '某社区党群服务中心', logo: '/images/clients/tsinghua.png' },
];
